"use client";

import * as React from "react";
import { Building2, Star, TrendingUp } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GoogleBusinessPageManagement() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-dark-background text-foreground-dark py-16 px-6 md:px-12 lg:px-20">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div ref={heroRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="relative">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/google_business_listing_hero.png" alt="Google Business Listing Dashboard" className="w-full h-auto rounded-xl shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)]" />
              <div className="absolute -top-4 -right-4 bg-accent text-foreground-accent rounded-full p-4 shadow-medium">
                <Star className="w-8 h-8" />
              </div>
            </div>
          </div>

          {}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-display font-bold mb-4 leading-tight">
                Google Business Page Management
              </h2>
              <p className="text-lg text-foreground-dark/80 leading-relaxed">
                Maximize your online visibility and connect with local customers through professional Google Business Profile management. We optimize your listing to drive more traffic, reviews, and conversions.
              </p>
            </div>

            {}
            <div className="space-y-6">
              {}
              <Card ref={card1Ref} className={`bg-muted-dark-background border border-border/30 rounded-xl p-6 shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${card1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} delay-100`} data-index={0}>
                <CardHeader className="p-0">
                  <div className="flex items-start gap-4">
                    <div className="bg-primary/20 p-3 rounded-lg">
                      <Building2 className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-xl text-foreground-dark mb-2">
                        Profile Optimization
                      </CardTitle>
                      <CardDescription className="text-foreground-dark/70">
                        Complete business information, high-quality photos, accurate categories, and regular updates to keep your profile fresh and engaging.
                      </CardDescription>
                    </div>
                  </div>
                </CardHeader>
              </Card>

              {}
              <Card ref={card2Ref} className={`bg-muted-dark-background border border-border/30 rounded-xl p-6 shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${card2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} delay-200`} data-index={1}>
                <CardHeader className="p-0">
                  <div className="flex items-start gap-4">
                    <div className="bg-secondary/20 p-3 rounded-lg">
                      <TrendingUp className="w-6 h-6 text-secondary" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-xl text-foreground-dark mb-2">
                        Performance Analytics
                      </CardTitle>
                      <CardDescription className="text-foreground-dark/70">
                        Track searches, views, clicks, and customer actions. Receive detailed monthly reports showing how your business performs in local search.
                      </CardDescription>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
}